/**
 * next-intl locale-aware navigation APIs.
 *
 * Plain `next/link` with a bare href (`/faq`) navigates to the
 * absolute path and DROPS any active locale prefix — so a visitor on
 * `/es/live-classes` who clicks a `next/link` to `/faq` lands on the
 * un-prefixed English URL instead of `/es/faq`. The locale resets.
 *
 * The `Link` exported here wraps next-intl's locale-aware navigation:
 * with `localePrefix: 'as-needed'` it prepends the active non-default
 * locale automatically (`/es/faq`) and leaves English bare (`/faq`).
 * External URLs (`https://…`) and hash links pass through untouched.
 *
 * Drop-in for `next/link` in user-facing components — same `href` +
 * `children` API. `useRouter` / `usePathname` / `redirect` mirror the
 * `next/navigation` equivalents but stay locale-aware.
 *
 * Admin (`src/app/admin/**`) and Sanity Studio routes live outside
 * the `[locale]` segment and should keep using plain `next/link`.
 */
import { createNavigation } from 'next-intl/navigation'
import { routing } from './routing'

export const { Link, redirect, usePathname, useRouter, getPathname } =
  createNavigation(routing)
